// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ol-5";
export var filledCircle = "_ol-4";
export var historyEntry = "_ol-3";
export var messageSideLeft = "_ol-1";
export var messageSideRight = "_ol-2";
export var orderTrackingCarouselWrapper = "_ol-6";
export var orderTrackingInfoContainer = "_ol-0";